import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility for merging Tailwind classes with proper precedence
 * Combines clsx for conditional classes and twMerge for Tailwind conflict resolution
 *
 * @example
 * cn("px-4 py-2", isActive && "bg-primary", className)
 * cn(buttonVariants({ variant, size }), className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
